import Vue from 'vue'
import Router from 'vue-router'

import UserList from '@/page/UserManage/UserList'
import UserPower from '@/page/UserManage/UserPower'
import BoardroomManage from '@/page/SystemSet/BoardroomManage'
import UnitsManage from '@/page/SystemSet/UnitsManage'
import SystemIndex from '@/page/SystemIndex/SystemIndex'
import SystemManage from '@/page/SystemSet/SystemManage'
import Remote from '@/page/RemoteMedical/Remote'
import CooperationRound from '@/page/RemoteMedical/CooperationRound'
import LiveCourse from '@/page/RemoteMedical/LiveCourse'
import RemoteExtend from '@/page/RemoteMedical/RemoteExtend'
import OnlineCourse from '@/page/RemoteMedical/OnlineCourse'
import Layout from '@/page/layout/index'
import Login from '@/page/login/login'
import UpdatePsd from '@/page/login/updatePsd'
import MedicalAdvice from '@/page/RemoteMedical/MedicalAdvice'
import Notice from '@/page/RemoteMedical/notice'
import VedioPlay from '@/page/RemoteMedical/VedioPlay'
import VedioList from '@/page/RemoteMedical/VedioList'
import BtnManage from '@/page/SystemSet/BtnManage'
import Print from '@/page/print/Print'
import ConsluatationCount from '@/page/Statistics/ConsluatationCount.vue'
import RoundCount from '@/page/Statistics/RoundCount.vue'
import LiveCourseStatistics from '@/page/Statistics/LiveCourseStatistics.vue'
Vue.use(Router)

export const constantRouterMap = [
  {
    path:'/login',
    name:'Login',
    component: Login
  },
  {
    path: '/index',
    name: 'Layout',
    component: Layout,
    children:[]
  },
]
export const asyncRouterMap = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path:'/login',
    name:'login',
    component: Login
  },
  {
    path: '/index',
    name: 'Layout',
    component: Layout,
    children:[
      {
        path: '/liveCourseStatistics', //直播课程统计
        name:'liveCourseStatistics',
        component: LiveCourseStatistics
      },
      {
        path: '/ConsluatationCount', // 会诊统计
        name: 'ConsluatationCount',
        component: ConsluatationCount
      },
      {
        path: '/RoundCount', // 查房统计
        name: 'RoundCount',
        component: RoundCount
      },
      {
        path: '/index', // 系统首页
        name: 'index',
        component: SystemIndex
      },
      {
        path: '/updatePsd', // 修改密码
        name: 'updatePsd',
        component: UpdatePsd
      },
      {
        path: '/userlist', //用户列表
        name: 'userlist',
        component: UserList
      },
      {
        path: '/userpower', //角色权限
        name: 'userpower',
        component: UserPower

      },
      {
        path: '/boardroom', //会议室管理
        name: 'boardroom',
        component: BoardroomManage
      },
      {
        path: '/unit', //单位管理
        name: '单位管理',
        component: UnitsManage
      },
      {
        path: '/remote',  //远程会诊
        name: 'remote',
        component: Remote
      },
      {
        path: '/RemoteExtend',  // 在线会议
        name: 'RemoteExtend',
        component: RemoteExtend
      },
      {
        path: '/cooperation', //协作查房
        name: 'cooperation',
        component: CooperationRound
      },
      {
        path: '/live',  //直播课程
        name: 'live',
        component: LiveCourse
      },
      {
        path: '/online', //在线课程
        name: 'online',
        component: OnlineCourse
      },
      {
        path: '/systemmanage', //菜单管理
        name: 'systemmanage',
        component: SystemManage
      },
      {
        path: '/medicalAdvice', //医疗咨询
        name:'medicalAdvice',
        component: MedicalAdvice
      },
      {
        path: '/notice', //医疗咨询
        name:'notice',
        component: Notice
      },
      {
        path: '/vediolist', //医疗咨询
        name:'vediolist',
        component: VedioList
      },
      {
        path: '/btnManage', //医疗咨询
        name:'btnmanage',
        component: BtnManage
      }
    ]
  },
  {
    path:'/print',
    name:'Print',
    component: Print
  },
  {
    path: '/vedioplay', //医疗咨询
    name:'vedioplay',
    component: VedioPlay
  },
  {
    path: '/video', 
    component: ()=> import('../page/RemoteMedical/video.vue')
  }
]
export default new Router({
  routes: asyncRouterMap,
})





// WEBPACK FOOTER //
// ./src/router/index.js